import React from 'react'
import moment from 'moment'
import Heatmap from './Heatmap'
import Graph from './Graph'
import createMeasurement from './Measurements'
import R from 'ramda'
import styled from 'styled-components'

const ColLabel = styled.text`
  stroke: #999;
`

const rows = R.range(0, 7).map(day => ({
  label: moment()
    .day(day)
    .format('ddd'),
  day,
}))

const dataToX = ({ data, cols, rectSize }) => {
  const m = moment(data.date)
    .clone()
    .day(0)
  return (
    R.findIndex(
      ({ year, week }) => year === m.year() && week === m.week(),
      cols
    ) * rectSize
  )
}

const createCols = ({ start, end }) => {
  const cols = []
  const endEnd = end.clone().hour(23)
  for (
    const loop = start.clone().day(0);
    loop.isBefore(endEnd);
    loop.add(1, 'weeks')
  ) {
    cols.push({ year: loop.year(), week: loop.week() })
  }
  return cols
}

const dataToY = ({ data, rectSize }) => moment(data.date).day() * rectSize

const renderColLabels = ({ cols, rectSize }) =>
  cols
    .map((data, index) => ({ index, ...data }))
    .filter(({ year, week }) => {
      const from = moment()
        .year(year)
        .week(week)
        .day(0)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)

      const to = moment()
        .year(year)
        .week(week)
        .day(6)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)

      const startOfMonth = to.clone().startOf('month')

      return from.isSameOrBefore(startOfMonth) && to.isSameOrAfter(startOfMonth)
    })
    .map(({ year, week, index }) => (
      <ColLabel
        y={0}
        x={index * rectSize}
        transform={`translate(0,${rectSize * -0.2})`}
        key={`${year}-${week}-${index}-label`}
      >
        {moment()
          .year(year)
          .week(week)
          .day(6)
          .format('MMM YYYY')}
      </ColLabel>
    ))

const CalendarHeatMap = ({
  start,
  end,
  data,
  colors,
  margin = { top: 30, right: 0, bottom: 50, left: 40 },
  height = 190,
  colorKey = 'value',
  squareWidth = 20,
  tooltipRenderer = a => `${moment(a.date).format('YYYY-MM-DD')}: ${a.value}`,
  legendDimension = { width: 60, height: 10 },
  style = {},
  width = 800,
  onClick,
  isSelected,
  dataToValue,
}) => {
  const cols = createCols({ start, end })
  const measurement = createMeasurement({
    margin,
    height,
    width: Math.max(
      squareWidth * cols.length + margin.left + margin.right,
      width
    ),
  })
  const gProps = { measurement }
  return (
    <div
      style={{
        ...style,
        height: `${height + 20}px`,
        width: `${width}px`,
        overflow: 'auto',
      }}
    >
      <Graph {...gProps}>
        <Heatmap
          {...gProps}
          cols={cols}
          rows={rows}
          data={data}
          colors={colors}
          colorKey={colorKey}
          dataToY={dataToY}
          dataToX={dataToX}
          legendDimension={legendDimension}
          tooltipRenderer={tooltipRenderer}
          squareWidth={squareWidth}
          renderColLabels={renderColLabels}
          onClick={onClick}
          isSelected={isSelected}
          hideLegend={colors.length <= 2}
          dataToValue={dataToValue}
        />
      </Graph>
    </div>
  )
}

export default CalendarHeatMap
